/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewNameItem } from './CRSFSecReviewNameItem';
import {
    CRSFSecReviewNameItemFromJSON,
    CRSFSecReviewNameItemFromJSONTyped,
    CRSFSecReviewNameItemToJSON,
} from './CRSFSecReviewNameItem';

/**
 * 
 * @export
 * @interface CRSFSecReviewMetaItem
 */
export interface CRSFSecReviewMetaItem {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewMetaItem
     */
    ARank?: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewMetaItem
     */
    City?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewMetaItem
     */
    CompanyName?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewMetaItem
     */
    Country?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewMetaItem
     */
    Emails?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewMetaItem
     */
    Majestic?: number;
    /**
     * 
     * @type {Array<CRSFSecReviewNameItem>}
     * @memberof CRSFSecReviewMetaItem
     */
    Names?: Array<CRSFSecReviewNameItem>;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewMetaItem
     */
    Postcode?: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewMetaItem
     */
    QRank?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewMetaItem
     */
    Social?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewMetaItem
     */
    State?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewMetaItem
     */
    Telephones?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewMetaItem
     */
    Umbrella?: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewMetaItem
     */
    Vertical?: string;
}

/**
 * Check if a given object implements the CRSFSecReviewMetaItem interface.
 */
export function instanceOfCRSFSecReviewMetaItem(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFSecReviewMetaItemFromJSON(json: any): CRSFSecReviewMetaItem {
    return CRSFSecReviewMetaItemFromJSONTyped(json, false);
}

export function CRSFSecReviewMetaItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewMetaItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ARank': !exists(json, 'ARank') ? undefined : json['ARank'],
        'City': !exists(json, 'City') ? undefined : json['City'],
        'CompanyName': !exists(json, 'CompanyName') ? undefined : json['CompanyName'],
        'Country': !exists(json, 'Country') ? undefined : json['Country'],
        'Emails': !exists(json, 'Emails') ? undefined : json['Emails'],
        'Majestic': !exists(json, 'Majestic') ? undefined : json['Majestic'],
        'Names': !exists(json, 'Names') ? undefined : ((json['Names'] as Array<any>).map(CRSFSecReviewNameItemFromJSON)),
        'Postcode': !exists(json, 'Postcode') ? undefined : json['Postcode'],
        'QRank': !exists(json, 'QRank') ? undefined : json['QRank'],
        'Social': !exists(json, 'Social') ? undefined : json['Social'],
        'State': !exists(json, 'State') ? undefined : json['State'],
        'Telephones': !exists(json, 'Telephones') ? undefined : json['Telephones'],
        'Umbrella': !exists(json, 'Umbrella') ? undefined : json['Umbrella'],
        'Vertical': !exists(json, 'Vertical') ? undefined : json['Vertical'],
    };
}

export function CRSFSecReviewMetaItemToJSON(value?: CRSFSecReviewMetaItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ARank': value.ARank,
        'City': value.City,
        'CompanyName': value.CompanyName,
        'Country': value.Country,
        'Emails': value.Emails,
        'Majestic': value.Majestic,
        'Names': value.Names === undefined ? undefined : ((value.Names as Array<any>).map(CRSFSecReviewNameItemToJSON)),
        'Postcode': value.Postcode,
        'QRank': value.QRank,
        'Social': value.Social,
        'State': value.State,
        'Telephones': value.Telephones,
        'Umbrella': value.Umbrella,
        'Vertical': value.Vertical,
    };
}

